import { TextField, InputAdornment, ButtonBase } from "@material-ui/core";
import { Modal } from "src/components";
import { makeStyles } from "@material-ui/styles";
import { Search as SearchIcon } from "@material-ui/icons";

const useStyles = makeStyles({
  textField: {
    width: "100%",
    maxWidth: "100%",
  },
});

function InputSearch({
  modal,
  openmodal,
  label,
  values = { id: 0, label: "" },
  children,
  inputProps,
  modalProps,
}) {
  const classes = useStyles();
  return (
    <>
      <Modal {...modalProps} open={modal}>
        {children}
      </Modal>
      <TextField
        {...inputProps}
        className={classes.textField}
        label={label}
        value={values.label}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        margin="dense"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" style={{}}>
              {values.id > 0 ? values.id : ""}
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              style={{}}
              onClick={() => openmodal()}
            >
              <ButtonBase>
                <SearchIcon />
              </ButtonBase>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}

export default InputSearch;
